import { dynamicRoutes } from '../../static/Routes'

const { PUBLIC_URL = '' } = process.env

//FIXME: This function is used to open PDF data so user can download. Files are stored in Public folder.

const handleDownloadHref = (data: String) => {
  if (data === dynamicRoutes.grievance) {
    return '/docs/Grievance/Grievance-Redressal-Policy.pdf'
  } else {
    return ''
  }
}

export const handleRoute = (data: string, navigate: any) => {
  if (data === 'privacy') {
    window.open('https://www.jiomoney.com/privacy.html', '_blank')
  } else if (data === 'tnc') {
    window.open('https://www.jiomoney.com/tandc.html', '_blank')
  } else if (data === 'playstore') {
    window.open('https://play.google.com/store/apps/details?id=com.jiopay.business', '_blank')
  }
  //TODO: Uncomment this line if you want PDF files to open separately.
  else if (data === dynamicRoutes.grievance) {
    let downloadLink = handleDownloadHref(data)
    window.open(`${PUBLIC_URL}` + downloadLink, '_blank')
  } else {
    navigate(data)
  }
}
